var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-us",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require("../assets/frame.svg"),"alt":""}}),_vm._v(" 联系我们 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }